/* eslint-disable react/button-has-type */
import React from 'react';

function Button({
  className,
  children,
  ...props
}: React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>) {
  return (
    <button
      className={`py-2 px-4 bg-color-primary-300 rounded w-full font-semibold tracking-wide transition-colors
      ${!className?.includes('text') && 'text-white'}
      ${!className?.includes('bg') && 'bg-color-primary-300'}
      ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}

export default Button;
